import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage', {
    title: 'Budgeting | {companyName}',
    syncEnabled: 'Budget synchronisation with {integrationName} is enabled',
    syncDisabled: 'Budget synchronisation with {integrationName} is disabled',
    syncSuccessful: 'Successful budget synchronization',
    successUpdated: 'Budget updated',
});
